import React from 'react';
import { motion } from 'framer-motion';
export function Chef() {
  return <section className="py-32 bg-dark relative overflow-hidden" dir="rtl" data-id="element-11">
      <div className="container mx-auto px-6 md:px-12" data-id="element-12">
        <div className="flex flex-col md:flex-row items-center gap-16 lg:gap-32" data-id="element-13">
          {/* Chef Image Block */}
          <motion.div className="w-full md:w-5/12 relative" initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: 'easeOut'
        }} data-id="element-14">
            <div className="aspect-[3/4] w-full bg-chef-bg relative rounded-sm overflow-hidden shadow-2xl" data-id="element-15">
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(201,168,106,0.15)_0%,transparent_70%)]" data-id="element-16" />
              <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-dark to-transparent" data-id="element-17" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-8 -right-8 w-32 h-32 border-r border-b border-gold/30" data-id="element-18" />
            <div className="absolute -top-8 -left-8 w-32 h-32 border-l border-t border-gold/30" data-id="element-19" />
          </motion.div>

          {/* Chef Bio */}
          <motion.div className="w-full md:w-7/12 flex flex-col items-start" initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: 'easeOut',
          delay: 0.2
        }} data-id="element-20">
            <span className="font-sans text-gold text-sm tracking-widest uppercase mb-6" data-id="element-21">
              השף שלנו
            </span>
            <h2 className="font-serif text-5xl md:text-6xl text-cream mb-8" data-id="element-22">
              אריאל כהן
            </h2>

            <div className="space-y-6 font-sans text-cream/70 text-lg leading-relaxed max-w-xl" data-id="element-23">
              <p data-id="element-24">
                לאחר עשור של עבודה במטבחי המישלן המובילים בפריז וסן סבסטיאן, חזר
                אריאל לישראל עם חזון ברור: ליצור מטבח מקומי עילי שמדבר בשפה
                בינלאומית אך נטוע עמוק באדמה המקומית.
              </p>
              <p data-id="element-25">
                "הבישול עבורי הוא חיפוש מתמיד אחר השלמות שבפשטות. לקחת חומר גלם
                אחד, בשיא עונתו, ולהעניק לו את הכבוד הראוי לו דרך טכניקה מדויקת
                והרבה אהבה."
              </p>
            </div>

            <div className="mt-12" data-id="element-26">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Signature_of_John_Hancock.svg/1200px-Signature_of_John_Hancock.svg.png" alt="Chef Signature" className="h-16 invert opacity-50 filter sepia hue-rotate-15" style={{
              filter: 'invert(1) sepia(1) saturate(3) hue-rotate(340deg) brightness(0.8) opacity(0.6)'
            }} data-id="element-27" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}